import * as React from "react";

export type Page = {
  section: string;
  params?: any;
};

let _check = "";

export default function usePage(): [Page, any] {
  const [page, setPage] = React.useState<Page>({
    section: _check
  });

  React.useEffect(() => {
    const check = () => {
      let p = window.location.hash;
      if (p !== _check) {
        _check = p;
        if (p.length > 1) {
          let s = p.substring(1).split(":");
          setPage({
            section: s[0],
            params: s.length > 1 ? s[1] : undefined
          });
        } else {
          setPage({
            section: ""
          });
        }
      }
    };
    const disposer = setInterval(check, 500);

    return () => {
      clearInterval(disposer);
    };
  }, []);

  return [page, setPage];
}
